import { render, staticRenderFns } from "./ed-edit-dialog.component.vue?vue&type=template&id=18302c13&scoped=true&"
import script from "./ed-edit-dialog.component.ts?vue&type=script&lang=ts&"
export * from "./ed-edit-dialog.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-edit-dialog.component.scss?vue&type=style&index=0&id=18302c13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18302c13",
  null
  
)

export default component.exports